import { create } from 'zustand';

export let useCreatePartModal = create((set, get) => ({
	display: false,

	showCreatePartModal: (v) => {
		set({ display: true });
	},

	closeModal: () => {
		set({ display: false });
	},
}));
